import React, { useEffect, useState } from 'react';
import { useConfig } from '../contexts/ConfigContext';
import { TCompany, TModule, useCompany } from '../contexts/CompanyContext';
import SideBar from '../components/SideBar';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer'
import { app } from '../config/const';
import { contentPath, modules } from '../config/pages';
import useAuth from '../hooks/useAuth';
import { useUser } from '../contexts/UserContext';
import { Layout, Spin } from "antd";
import { useHistory } from 'react-router-dom';
import CalendarProviders from '../components/CalendarProviders';
import Forbidden from './Forbidden';

const { Content } = Layout;

const navOptions = [
  modules.Calendar,
  modules.Home,
  modules.Tracking,
  modules.Contacts,
];

const Index = (props:any) => {
  const { config,updateConfig } = useConfig()
  const {company,updateCompany} = useCompany()
  const {updateUser} = useUser()
  const [isForbidden, setIsForbidden] = useState(false)
  const history = useHistory()
  const companyUidFromQuery = new URLSearchParams(globalThis.location.search).get('company');
  const {tokenData} = useAuth.useToken('authCsrfToken',config.session,config.key)
  const {data:indexData} = useAuth.useIndex(tokenData,{
    session:config.session,
    company: companyUidFromQuery || company.current.uid,
    module: config.module || 'INDEX'
  })
  
  useEffect(()=>{
    if(tokenData && indexData?.user){
      console.log(indexData)
      const targetUid = companyUidFromQuery || company.current.uid;
      const defaultCompany = indexData.companies.find((comp: any) => 
        indexData.permissions?.some((el: any) => el.key.toUpperCase().startsWith(app.Calendar) && el.company_id === comp.id) &&
        indexData.modules?.some((mod: any) => mod.app.toUpperCase() === app.Calendar && mod.company_id === comp.id)
      ) ?? indexData.companies.find((comp: any) => 
        indexData.permissions?.some((el: any) => el.key.toUpperCase().startsWith(app.Calendar) && el.company_id === comp.id)
      ) ?? indexData.companies.find((comp: any) => 
        indexData.modules?.some((mod: any) => mod.app.toUpperCase() === app.Calendar && mod.company_id === comp.id)
      ) ?? indexData.companies[0];
      const currentCompany = targetUid ? (indexData.companies.find((comp:TCompany) => comp.uid === targetUid) ?? defaultCompany) : defaultCompany;
      const currentModule = indexData.modules.find((mod:TModule) => mod.app.toUpperCase() === app.Calendar && mod.company_id === currentCompany.id)

      currentCompany.modules = indexData.modules.filter((mod:TModule) => mod.company_id === currentCompany.id)
      if (indexData.subscriptions) {
        currentCompany.subscription = indexData.subscriptions.find((sub:any) => sub.company_id === currentCompany.id)
      }
      console.log(currentModule)
      updateConfig({key:tokenData.key,module: props.module,showProgress:false})
      const userViews: string[] = indexData.permissions.filter((el:any) => el.type === 'VIEW' && el.company_id === currentCompany.id).map((el:any) => el.key);
      updateUser({...indexData.user,
        permissions:{
          views: userViews,
          actions: indexData.permissions.filter((el:any) => el.type === 'ACTION' && el.company_id === currentCompany.id).map((el:any) => el.key)
        },
        roles:indexData.permissions
      })
      const moduleOptions = indexData.module_options.filter((el:any) => (el.module_id === currentModule?.id || !el.module_id) && el.company_id === currentCompany.id)
      updateCompany({
        current:{...currentCompany},
        list:indexData.companies,
        moduleList:indexData.modules,
        currentModule:currentModule,
        moduleOptions:moduleOptions
      })
      
      if(indexData?.permissions){
        const modulePermission = indexData.permissions?.some((el:any) => el.key.toUpperCase().startsWith(app.Calendar) && el.company_id === currentCompany.id)
        const hasModule = Boolean(currentModule)
        if(!modulePermission || !hasModule){
          setIsForbidden(true)
        } else {
          setIsForbidden(false)
          if(props.module === modules.Calendar && !userViews.some((v: string) => v.toLowerCase().includes(modules.Calendar.toLowerCase()))){
            const firstAvailable = navOptions.find(key => userViews.some(v => v.toLowerCase().includes(key.toLowerCase())));
            if(firstAvailable){
              history.replace(contentPath[firstAvailable]);
            }
          }
        }
      }
    }
  },[tokenData,indexData,config.showProgress])

  const getPadding = () => {
    if(config.sideVisible && !config.isMobile){
      return config.sideCollapsed ? 80 : 250
    }
    return 0
  }
  
  const MainContent = isForbidden ? Forbidden : props.content

  return (
    <CalendarProviders>
      <Layout style={{ minHeight: "100vh" }}>
        {!isForbidden && config.sideVisible && <SideBar/>}
        <Spin size="large" tip="Cargando..."  fullscreen spinning={config.showProgress}/>
        <Layout style={{ paddingLeft: !isForbidden ? getPadding() : 0, transition: "0.3s" }}>
          <TopBar></TopBar> 
          <Content style={{ 
            margin: config.isMobile ? "8px 4px" : "16px", 
            padding: config.isMobile ? "12px 8px" : "24px", 
            background: "#fff", 
            minHeight: "calc(100vh - 112px)", 
            borderRadius: config.isMobile ? 4 : 8 
          }}>
            <MainContent />
          </Content>
          <Footer />
        </Layout>
      </Layout>
    </CalendarProviders>
  )
}

export default Index;

